import { DebriefScore } from './debriefscore';
import { ActivityModel } from './activitymodel';

export class DebriefModel{
    public score:DebriefScore;
    public rankTextBody:string;
    public activities:ActivityModel[] = [];
}

